import { render, staticRenderFns } from "./baseContent.vue?vue&type=template&id=61885fc7&scoped=true&"
import script from "./baseContent.vue?vue&type=script&lang=js&"
export * from "./baseContent.vue?vue&type=script&lang=js&"
import style0 from "./baseContent.vue?vue&type=style&index=0&id=61885fc7&prod&scoped=true&lang=css&"
import style1 from "./baseContent.vue?vue&type=style&index=1&id=61885fc7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61885fc7",
  null
  
)

export default component.exports